import { Link } from "react-router-dom";
import { orderStatusLabel, orderTone, paymentLabel, paymentTone } from "../constant/enum";

export const Badge = ({ tone = "", children }) => <span className={`badge ${tone}`}>{children}</span>;
export const OrderBadge = ({ status }) => <Badge tone={orderTone[status] || ""}>{orderStatusLabel[status] || status}</Badge>;
export const PaymentBadge = ({ status }) => <Badge tone={paymentTone[status] ?? ""}>{paymentLabel[status] || status}</Badge>;

export function Toggle({ checked, onChange, label, disabled }) {
  return <button type="button" className="toggle" role="switch" aria-checked={Boolean(checked)} aria-label={label} onClick={onChange} disabled={disabled} />;
}

export function PageHead({ title, sub, back, children }) {
  return (
    <div className="page-head">
      <div>
        {back ? (
          <Link to={back.to} className="back">
            <i className="bi bi-arrow-left" /> {back.label}
          </Link>
        ) : null}
        <h1>{title}</h1>
        {sub ? <p>{sub}</p> : null}
      </div>
      {children ? <div className="row-wrap">{children}</div> : null}
    </div>
  );
}

export function Empty({ icon = "bi-inbox", title, text, children }) {
  return (
    <div className="empty">
      <i className={`bi ${icon}`} />
      <h3>{title}</h3>
      {text ? <p>{text}</p> : null}
      {children}
    </div>
  );
}

export function Loading({ rows = 5 }) {
  return (
    <div style={{ padding: 18, display: "grid", gap: 10 }} aria-busy="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: 34 }} />
      ))}
    </div>
  );
}

export function ErrorBox({ error, onRetry }) {
  return (
    <div className="empty" role="alert">
      <i className="bi bi-exclamation-circle" style={{ color: "var(--danger)" }} />
      <h3>Couldn't load this</h3>
      <p>{error?.data?.message || "The server didn't respond. Check your connection and try again."}</p>
      {onRetry ? (
        <button className="btn btn-ghost btn-sm" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function Pager({ pagination, onPage }) {
  if (!pagination) return null;
  const { page, pages, total, limit } = pagination;
  const from = total ? (page - 1) * limit + 1 : 0;
  return (
    <div className="pager">
      <span>
        {from}–{Math.min(total, page * limit)} of {total}
      </span>
      <div className="row">
        <button className="btn btn-ghost btn-sm" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          <i className="bi bi-chevron-left" /> Previous
        </button>
        <button className="btn btn-ghost btn-sm" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Next <i className="bi bi-chevron-right" />
        </button>
      </div>
    </div>
  );
}

export function SearchBox({ value, onChange, placeholder = "Search…" }) {
  return (
    <div className="search">
      <i className="bi bi-search" />
      <input className="input" type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder} />
    </div>
  );
}

export function Spinner() {
  return <span className="spinner" aria-hidden="true" />;
}
